<template>
      <a-col align="center">
        <a-row justify="space-between">
          <a-col :span="8"></a-col>
          <a-col :span="8" align="center">
            <img src="../../assets/icons/hino.svg" alt="HINO車隊">
          </a-col>
          <a-col :span="8" align="end">
            <img v-if="identidyInfo.productName === 'STMB-3000'" src="../../assets/icons/hino_logo.svg" alt="HINOICON">
          </a-col>
        </a-row>
        <h1 align="center" class="provisioning_title title_font_Weight">{{headerText}}</h1>
      </a-col>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: 'ProvisioningHeader',
        data() {
            return {
                currentPath: '/',
            }
        },
        mounted () {
            this.currentPath = this.$route.path;
        },
        computed: {
          ...mapState('identidyInfo', ['identidyInfo']),
          headerText() {
                if (this.currentPath === '/provisioning/step4') return '開通結果';
                else if (this.currentPath.indexOf('/enable/agree') !== -1) return '裝置納管';
                else return '裝置開通';
            },
        }  
    }
</script>

<style lang="scss" scoped>
    .provisioning_title {
        margin: 12px 0 18px 0;
    }
</style>